import { render } from "./ed-atom-enquiry-feedback-buttons.vue?vue&type=template&id=996fde8e"
import script from "./ed-atom-enquiry-feedback-buttons.vue?vue&type=script&lang=js"
export * from "./ed-atom-enquiry-feedback-buttons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__